<!-- HERO  -->
<section class="background-white hero-pricing welcome-section" style="height: 867px !important;">
  <div class="pattern-top-right"></div>
  <!-- <div class="pattern-bottom-left"></div> -->
  <div class="pricing-background-gradient-home" title="NuLifeSpan Rx provides prescription medication discounts for pharmacies nationwide">
    <div class="pricing-hero"></div>
  </div>
  <section class="comman-width">
    <!-- Header  -->
    <section class="header">
      <div class="medicine"></div>

      <h2 class="pricing-title">
        Sign up to save up to 80% on Prescriptions!
      </h2>
      <div class="search-fields" id="CheckLoginState">
        <app-search></app-search>
      </div>
      <!-- <div class="input">
        <input type="" placeholder="Type your drug name">
      </div> -->
    </section>
  </section>

</section>